export enum WeekDays {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface Schedule {
  weekday: WeekDays;
  active: boolean;
  timerange: {
    id: string;
    start: string;
    end: string;
  }[];
}

export interface Period {
  weekDay: WeekDays;
  startTime: string;
  endTime: string;
  id?: string;
}

export interface AutoExchangeFormValues {
  active?: boolean;
  rateSourceLifetimeSeconds: number | string;
  activeWeekDays?: WeekDays[];
  exchangeCurrencyFromId?: string;
  exchangeCurrencyToId?: string;
  maxAmountCurrencyId?: string;
  maxAmountPerOperation?: number | string;
  minAmountPerOperation?: number | string;
  maxAmountForPeriod?: number | string;
  maxAmountPeriodInHours?: number;
  periods?: Period[];
  exchangeType?: string;
  accountsType?: string;
  primaryAccountIds?: string[];
  createChildrenTransactions?: boolean;
  fromAccountId?: string | null;
  toAccountId?: string | null;
  rateSourceId?: string | null;
  targetStatus?: string;
}

export interface AutoExchangeSettings {
  id: string;
  activeWeekDays?: WeekDays[];
  exchangeCurrencyToId: string;
  exchangeCurrencyFromId: string;
  maxAmountCurrencyId: string;
  active: boolean;
  maxAmountPerOperation: number;
  minAmountPerOperation: number;
  maxAmountForPeriod: number;
  maxAmountPeriodInHours: number;
  rateSourceLifetimeSeconds: number;
  url?: string;
  periods?: Period[];
  accountsType?: string;
  primaryAccountIds?: string[];
  createChildrenTransactions?: boolean;
  fromAccountId?: string;
  toAccountId?: string;
  rateSourceId?: string;
  targetStatus?: string;
  render?: Record<string, React.JSX.Element>;
}

export enum ChartType {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export interface Category {
  active: boolean;
  id: string;
  isClientAccount: boolean;
  name: string;
  type?: ChartType;
  accountGroups?: Group[];
  number: string;
}

export interface Group {
  id: string;
  description: string;
  number: string;
  active?: boolean;
  categoryId?: string;
  category?: Category;
  isClientAccount?: boolean;
  primaryAccounts?: PrimaryAccount[];
}

export interface PrimaryAccount {
  description: string;
  number: string;
  active: boolean;
  groupId: string;
  group: Group;
  id: string;
}
